export function operacaoNotaFiscalDescargasInRequest(params = {}) {
  return {
    type: '@operacaonotafiscaldescargas/NOTAFISCALDESCARGAS_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoNotaFiscalDescargas(nfre_numero) {
  return {
    type: '@operacaonotafiscaldescargas/FIND_NOTAFISCALDESCARGAS',
    payload: { nfre_numero },
  };
}

export function failedRequest() {
  return {
    type: '@operacaonotafiscaldescargas/FAILED_REQUEST',
  };
}

export function deleteOperacaoNotaFiscalDescargas(nfre_numero, params) {
  return {
    type: '@operacaonotafiscaldescargas/DELETE_NOTAFISCALDESCARGAS',
    payload: { nfre_numero, params },
  };
}

export function updateOperacaoNotaFiscalDescargas(operacaonotafiscaldescargas, params) {
  return {
    type: '@operacaonotafiscaldescargas/UPDATE_NOTAFISCALDESCARGAS',
    payload: { operacaonotafiscaldescargas, params },
  };
}

export function storeOperacaoNotaFiscalDescargas(operacaonotafiscaldescargas, params) {
  return {
    type: '@operacaonotafiscaldescargas/STORE_NOTAFISCALDESCARGAS',
    payload: { operacaonotafiscaldescargas, params },
  };
}

export function successInRequest(
  operacaonotafiscaldescargas,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaonotafiscaldescargas/SUCCESS_IN_REQUEST',
    payload: { operacaonotafiscaldescargas, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaonotafiscaldescargas) {
  return {
    type: '@operacaonotafiscaldescargas/SUCCESS_REQUEST',
    payload: { operacaonotafiscaldescargas },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaonotafiscaldescargas/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaonotafiscaldescargas/RECORD_FILTERING',
    payload: { params },
  };
}
